import GPFilterRow from '@/components/GPFilterRow';
import GPSearchField from '@/components/GPSearchField';
import { FormSectionType } from '@/types/forms';
import { Box, Stack, Theme, Typography, useMediaQuery } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import IconTabs, { ViewsType } from './IconTabs';

type HeaderInlineTabProps = {
  id?: string;
  subTabs?: boolean;
  searchHint?: string;
  currentView: ViewsType;
  tabTitle: string;
  setCurrentView: (view: ViewsType) => void;
  onSubmit?: () => void;
  viewTabs?: ViewsType[];
  showInputSearch?: boolean;
  showFilters?: boolean;
  showSearch?: boolean;
  filters?: FormSectionType[];
  visuallyHideTitle?: boolean;
};

const HeaderInlineTab = ({
  currentView,
  setCurrentView,
  searchHint,
  onSubmit,
  viewTabs = [],
  tabTitle,
  id = `search-${tabTitle}`,
  showInputSearch = true,
  showFilters = true,
  showSearch = true,
  filters,
  visuallyHideTitle = false,
}: HeaderInlineTabProps) => {
  const hasTabs = viewTabs && viewTabs.length > 0;
  const tabElement = (
    <IconTabs tabs={viewTabs} onClick={setCurrentView} currentView={currentView} />
  );

  const hasFilters = filters && showFilters && filters.length > 0;
  const filterElement = hasFilters && <GPFilterRow filterButtons={filters} />;

  const searchSectionElement = showSearch ? (
    <Box>
      <form onSubmit={onSubmit}>
        {showInputSearch && <GPSearchField id={id} name="keyword" hint={searchHint} />}
      </form>
    </Box>
  ) : null;
  const smDown = useMediaQuery<Theme>(theme => theme.breakpoints.down('sm'));

  // Search always spans its own full-width row; only filters share the inline row with the
  // view tabs, so tab-only views (e.g. badges) match the width of filtered views.
  const topElement = searchSectionElement;
  const inlineElement = hasFilters ? filterElement : null;
  const hasInlineElements = hasFilters || hasTabs;

  return (
    <Stack sx={{
      gap: 2
    }}>
      {tabTitle && (
        <Typography variant="h4" component="h2" sx={visuallyHideTitle ? visuallyHidden : undefined}>
          {tabTitle}
        </Typography>
      )}
      <Box>
        {topElement}
        {hasInlineElements ? (
          <Stack
            direction={'row'}
            sx={{
              justifyContent: inlineElement && tabElement ? 'space-between' : 'flex-end',
              width: "100%",
              alignItems: "center",
              marginBottom: hasFilters && !smDown ? 3 : 0
            }}>
            {inlineElement}
            {tabElement}
          </Stack>
        ) : null}
      </Box>
    </Stack>
  );
};

export default HeaderInlineTab;
